import React from 'react';
import { ImSpinner8 } from 'react-icons/im';

interface BadgeIndicatorProps {
    quantity: number;
    className?: string;
    loading?: Boolean;
    disabled?: boolean;
}

const BadgeIndicator = ({
    quantity,
    className,
    loading = false,
    disabled = false,
}: BadgeIndicatorProps) => {

    return (
        <span className={`absolute flex items-center justify-center text-xs text-white w-[22px] h-[22px] rounded-full font-medium leading-none ${disabled ? 'bg-gray-300' : 'bg-gray-600'} ${className}`}>
            {loading
                ? <ImSpinner8 className="animate-spin" size={14} />
                : quantity
            }
        </span>
    );
};

export default BadgeIndicator;
